"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.segmentColors = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var segmentColors = {
  0: 'bg-cyan-500',
  1: 'bg-green-500',
  2: 'bg-red-600',
  3: 'bg-yellow-300',
  4: 'bg-purple-700',
  5: 'bg-pink-500',
  6: 'bg-blue-400',
  7: 'bg-green-300',
  8: 'bg-red-900',
  9: 'bg-yellow-600'
};
exports.segmentColors = segmentColors;

var Bar = function Bar(_ref) {
  var segment = _ref.segment,
      onResizingStartSegment = _ref.onResizingStartSegment,
      onResizingEndSegment = _ref.onResizingEndSegment,
      segmentIndex = _ref.segmentIndex,
      startPoi = _ref.startPoi,
      endPoi = _ref.endPoi,
      intermediatePois = _ref.intermediatePois,
      onSelectedSegment = _ref.onSelectedSegment,
      isResizingSegment = _ref.isResizingSegment;
  var tooltipRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showTooltip = _useState2[0],
      setShowTooltip = _useState2[1];

  var tooltipLeft = 0;
  var tooltipTop = 0;

  if (tooltipRef.current) {
    var _tooltipRef$current$g = tooltipRef.current.getBoundingClientRect(),
        top = _tooltipRef$current$g.top,
        left = _tooltipRef$current$g.left,
        height = _tooltipRef$current$g.height,
        width = _tooltipRef$current$g.width; // + 8 for margin


    tooltipLeft = left + width + 8;
    tooltipTop = top + height / 2;
  }

  (0, _react.useEffect)(function () {
    if (isResizingSegment && showTooltip) {
      setShowTooltip(false);
    }
  }, [isResizingSegment, showTooltip]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: tooltipRef,
    key: "segment-".concat(segment),
    className: "absolute w-8 flex flex-col justify-between cursor-pointer rounded-lg shadow-lg ".concat(segmentColors[segmentIndex % 10]),
    style: {
      left: segment.x,
      top: segment.y,
      height: segment.height
    },
    onMouseEnter: function onMouseEnter() {
      return !isResizingSegment && setShowTooltip(true);
    },
    onMouseLeave: function onMouseLeave() {
      return !isResizingSegment && setShowTooltip(false);
    },
    onMouseUp: function onMouseUp() {
      return !isResizingSegment && onSelectedSegment(segmentIndex);
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    tabIndex: 0,
    className: "h-3 w-8 absolute focus:outline-none",
    onMouseDown: function onMouseDown() {
      return onResizingStartSegment(segmentIndex);
    },
    style: {
      cursor: 'n-resize',
      top: -6
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.resizeStartOfSegment"
  }))), /*#__PURE__*/_react["default"].createElement("button", {
    tabIndex: 0,
    className: "h-3 w-8 absolute focus:outline-none",
    onMouseDown: function onMouseDown() {
      return onResizingEndSegment(segmentIndex);
    },
    style: {
      cursor: 's-resize',
      bottom: -6
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.resizeEndOfSegment"
  }))), showTooltip && /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-white absolute p-2 z-30 shadow min-w-56 max-w-96 transform -translate-y-1/2",
    style: {
      left: tooltipLeft,
      top: tooltipTop
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-lg font-bold text-primary mb-1"
  }, "Segment ", segmentIndex + 1), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-start text-base mb-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-16 font-bold flex-shrink-0"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.from"
  }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, startPoi === null || startPoi === void 0 ? void 0 : startPoi.poiName)), intermediatePois.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-start text-base mb-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-16 font-bold flex-shrink-0"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.via"
  }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, intermediatePois.map(function (intermediatePoi) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "intermediatePoi-".concat(intermediatePoi.poiName)
    }, intermediatePoi.poiName);
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-start text-base"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-16 font-bold flex-shrink-0"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.to"
  }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, endPoi === null || endPoi === void 0 ? void 0 : endPoi.poiName))), document.body));
};

Bar.propTypes = {
  segment: _propTypes["default"].shape({
    x: _propTypes["default"].string,
    y: _propTypes["default"].string,
    height: _propTypes["default"].string
  }),
  onResizingStartSegment: _propTypes["default"].func,
  onResizingEndSegment: _propTypes["default"].func,
  segmentIndex: _propTypes["default"].number,
  startPoi: _propTypes["default"].shape({
    poiName: _propTypes["default"].string
  }),
  endPoi: _propTypes["default"].shape({
    poiName: _propTypes["default"].string
  }),
  intermediatePois: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    poiName: _propTypes["default"].string
  })),
  onSelectedSegment: _propTypes["default"].func,
  isResizingSegment: _propTypes["default"].bool
};

var noop = function noop() {};

Bar.defaultProps = {
  segment: {},
  onResizingStartSegment: function onResizingStartSegment() {},
  onResizingEndSegment: function onResizingEndSegment() {},
  segmentIndex: null,
  startPoi: {},
  endPoi: {},
  intermediatePois: [],
  onSelectedSegment: noop,
  isResizingSegment: false
};
var _default = Bar;
exports["default"] = _default;